import { Skeleton } from 'primereact/skeleton';
import classes from './unconstrainedForecastLoading.module.scss';

const UnconstrainedForecastLoadingSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="45rem"></Skeleton>
      </div>
    </div>
  );
};

export default UnconstrainedForecastLoadingSkeleton;
